import fetchClient from './fetchClient';
import { errorHandler } from './utils';



const config = () => ({
  headers: {
    Authorization: "Bearer " + localStorage.getItem("token"),
  },
});

// ---- CRUD TAGS ----

// GET all tags
export const getTags = async () => {
  const res: any = await fetchClient.get("/tags", config()).catch(errorHandler);
  if (!res) return null;
  return res.data;
};

// CREATE a tag
export const createTag = async (tag: { name: string; color: string }) => {
  const res: any = await fetchClient.post("/tags", tag, config()).catch(errorHandler);
  if (!res) return null;
  return res.data;
};

// UPDATE a tag
export const updateTag = async (id: string, tag: { name: string; color: string }) => {
  const res: any = await fetchClient.put(`/tags/${id}`, tag, config()).catch(errorHandler);
  if (!res) return null;
  return res.data;
};

// DELETE a tag
export const deleteTag = async (id: string) => {
  const res: any = await fetchClient.delete(`/tags/${id}`, config()).catch(errorHandler);
  if (!res) return null;
  return res.data;
};
